import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './IbanInput.html?raw';
import docu from './IbanInputDocumentation.html?raw';
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';
//import DataItems = require("DataItems");


class IbanInput extends compose(_LabelInputBase) {
    templateString: any = template;

    inputNode: HTMLInputElement;
    labelNode: HTMLLabelElement;
    errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer = "errorMsgNode";
    validationControllerUrl: string = "ArtistRegistration/ValidateIban";

    title: string;
    maskDelimeter: string = " ";

    __oldInputValue: string = "";
    __newInputValue: string = "";
    __oldString: string = ""; // for cursor not to jump aroud
    
    __request: dojo.request.Promise<any>;
    validationResponse: any;

    _requestTimeout: number = null;

    errorMap_IBAN_translations = [(this as any).translations['Error__IBANValidation_ValueMissing'], (this as any).translations['Error__IBANValidation_ValueTooSmall'], (this as any).translations['Error__IBANValidation_ValueTooBig'],
                                 (this as any).translations['Error__IBANValidation_CheckFail'], (this as any).translations['Error__IBANValidation_CountryCodeFail']];

    errorMap_IBAN_string: Array<string> = ["Value missing", "Value too small", "Value too big", "Value fails Modulo 97 Check", "Unknown country"];


    // Property Getters & Setters --------------------------------START
    protected setInputValue(): void {

        let newString: string = "";

        for (let i = 0; i < this._value.length; i = i + 4) {

            let chunk: string = this._value.slice(i, i + 4);

            newString += chunk + this.maskDelimeter;
        }

        this.inputNode.value = newString.trim();
    }

    getValidationResponce(): any {
        return this.validationResponse;
    }

    setTitle(title: string): void {
        this.title = title;
        this.UiModder.domAttr.set(this.inputNode, "title", title);
    }

    getTitle(): string {
        return this.title;
    }

    setValidationControllerUrl(url: string): void {
        this.validationControllerUrl = url;
    }

    getValidationControllerUrl(): string {
        return this.validationControllerUrl;
    }
    // Property Getters & Setters --------------------------------END

    // Label-------------------------------------------------------START
    protected setLabelValue(): void {
        this.labelNode.textContent = this._label;
    }

    //protected setIsLabelVisibleStyle(visibility: boolean): void {
    //    this._isLabelVisible ? this.UiModder.domClass.remove(this.labelNode, "w3-hide") : this.UiModder.domClass.add(this.labelNode, "w3-hide");
    //}

    protected setPlaceholderValue(): void {
        this.inputNode.placeholder = this.placeholder;
    }
    // Label-------------------------------------------------------END

    // Value ---------------------------------------------------START
    setValue(newValue: any, suppressChangeEvent: boolean = false): void {

        this._value = newValue;
        this.setInputValue();

        if (suppressChangeEvent === true) { }
        else {
            this.__delayValueChangeEmit();
        }

        if (this.validationEnabled) {
            this.validateInput();
        } else {
            this.isValid = true;
        }
    }
    // Value ---------------------------------------------------END

    // Style ------------------------------------------------------START
    protected _setValidationResultStyle(): void {
        // wird in kindklasse ausprogrammiert
        let messageNodes = (this.domNode.getElementsByClassName("moreCore_ValidationMsgError"));

        for (let i = 0; i < messageNodes.length; i++) {
            this.UiModder.domConstruct.destroy(messageNodes[i])
        }

        if (!this.isValid && this.validationEnabled === true) {
            if (messageNodes.length == 0) {
                this._insertValidationMsgErrorNode(this.validationErrorMsgText);
            }
        }

    }

    // Style ------------------------------------------------------END

    // Validation ----------------------------------------------------START

    validateIbanDelayed(delay?: number): void {
        if (typeof (delay) == "undefined") {
            delay = 500;
        }

        if (this._requestTimeout != null) {
            clearTimeout(this._requestTimeout);
            this._requestTimeout = null;
        }

        this._requestTimeout = setTimeout(lang.hitch(this, function () {
            this._onChange_InputNode();
        }), delay);
    }

    validateInput(): boolean {

        let iban: string = this.getValue();

        let requestUrl: string = null;

        if (this.validationControllerUrl) {
            requestUrl = window.appRoot + this.validationControllerUrl;
        } else {
            console.log('BAD Url for IBAN Validation')
            return;
        }

        let requestParams = {
            "iban": iban
        };

        this.__request = this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, this._onValidateIBAN_Response),
            lang.hitch(this, this._onValidateIBAN_Error),
        );

        return null;
    }

    protected _onValidateIBAN_Response(response):void {

        this.validationResponse = response;

        let errorCode: number;
        let errorMap: Array<string>;


        if (this.validationResponse >= 1) {
            errorCode = this.validationResponse - 1;
            this.translations ? errorMap = this.errorMap_IBAN_translations : errorMap = this.errorMap_IBAN_string;
            this.validationErrorMsgText = errorMap[errorCode];
            this.isValid = false
            this.emit("IbanValidationREsponse", { isValid: false });
            this._setValidationResultStyle();
        } else if (this.validationResponse === 0) {
            this.isValid = true;
            this.emit("IbanValidationREsponse", { isValid: true });
            this._setValidationResultStyle();
        }
    }

    protected _onValidateIBAN_Error(err): void {
        this.isValid = false;
        console.log("ValidateIban: error: ", err);
    }

    // Validation ----------------------------------------------------END


    // Events-----------------------------------------------------START

    _onChange_InputNode(): void {
        let value: string = this.inputNode.value.replace(/[-.'"´:; ,.<>\\/]+/g, "").toUpperCase();
        this.setValue(value);
    }

    _onKeyUp_InputNode(): void {
        // strip bad input
        let value:string = this.inputNode.value.replace(/[-.'"´:; ,.<>\\/]+/g, "");
        let newString: string = "";

        this.__newInputValue = value; 

        // if character was added
        if (this.__newInputValue.length > this.__oldInputValue.length) {


            // construct a new string for display (this._value is still plain, without delimeter)
            for (let i:number = 0; i < value.length; i = i + 4) {
                let chunk: string = value.slice(i, i + 4);
                if (value.length - i < 5) {
                    newString += chunk.toUpperCase()
                } else {
                    newString += chunk.toUpperCase() + this.maskDelimeter;
                }
            }

            this.inputNode.value = newString;

            //put the cursor on the place that was formated last
            if (this.__oldString) {

                let insertedLength: number = (newString.length - this.__oldString.length);  // how many characters were inserted

                for (let i = 0; i < newString.length; i++) {
                    if (newString[i] != this.__oldString[i]) {
                        this.inputNode.setSelectionRange(i + insertedLength, i + insertedLength);
                        break;
                    }
                }
            }

            this.__oldString = newString;
        } else {
            this.__oldString = this.inputNode.value; // to get the right __oldString.length after deleting characters and inserting a new chunk
        }


        this.__oldInputValue = this.__newInputValue;

        this.validateIbanDelayed(2000);
    }

    setMaskDelimeter(delimeter: string): void {
        this.maskDelimeter = delimeter;
    }
    // Events-----------------------------------------------------END


    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // Dojo ------------------------------------------------------START
    _setValidationControllerUrlAttr(url: string): void {
        this.validationControllerUrl = url;
    }

    _setMaskDelimeterAttr(delimeter: string): void {
        this.maskDelimeter = delimeter;
    }

    _setTitleAttr(title: string) {
        this.setTitle(title);
    }

    _getTitleAttr(): string {
        return this.getTitle();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(IbanInput);